import { render, staticRenderFns } from "./GetStatusInTable.vue?vue&type=template&id=87d99848&"
import script from "./GetStatusInTable.vue?vue&type=script&lang=js&"
export * from "./GetStatusInTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports